import React from 'react';

import { LogoVariant } from '@benzinga/logos-ui';
import { FooterLink as IFooterLink, FooterNavigationGroup, SocialSites } from './footerEntity';
import { SimpleFooter } from './Variants/Simple/SimpleFooter';
import { NewDefaultFooter } from './Variants/NewDefault/NewDefaultFooter';
import { FooterVariant } from '../../entities';
import { DefaultFooter } from './Variants/Default/DefaultFooter';

export interface NavigationFooterProps {
  showStickyFooter?: boolean;
  socialMedia?: SocialSites;
  showAppList?: boolean;
  showFooterLinksTable?: boolean;
  menu?: FooterNavigationGroup[];
  copyrightLinks?: IFooterLink[];
  variant?: FooterVariant;
  logoVariant?: LogoVariant;
  isIndiaFooter?: boolean;
}

export const NavigationFooter: React.FC<NavigationFooterProps> = ({ isIndiaFooter, variant, ...props }) => {
  const footerVariants = {
    simple: SimpleFooter,
  };

  const FooterComponent = footerVariants[variant ?? ''];

  if (FooterComponent) {
    return <FooterComponent {...props} />;
  }
  if (isIndiaFooter) {
    return <DefaultFooter {...props} />;
  }

  return <NewDefaultFooter {...props} />;
};

export default NavigationFooter;
